import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../components/HomeView.vue'
import EmploymentView from '../components/EmploymentView.vue'
const routes = [
    {
        path: '/',
        name: `home`,
        component: HomeView,
        meta: {
            title: 'RSJ株式会社'
        }
    },
    {
        path: '/employment',
        name: 'employment',
        component: EmploymentView,
        meta: {
            title: '採用情報 | RSJ株式会社'
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.Base_URL),
    routes,
    scrollBehavior() {
        return { top: 0 }
    }
})
router.afterEach((titleString) => {
    document.title = titleString.meta.title
})
export default router